import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
    Button, Tabs, Badge, Divider, Spin, Layout, Tooltip, Icon,
} from 'antd';
import { Link } from 'react-router-dom';
import { leadApprovalGetLeadsRequest } from './redux/actions/lead_approval_get_leads.actions';
import DenyLeadApproveModal from './components/DenyLeadApproveModal';
import { setLeadApproveRequest } from './redux/actions/set_lead_approve.actions';
import { get } from '../../../shared/helpers';
import { checkPermissionsHOC } from '../../App/CheckPermissions';
import { NotFound } from '../../App/components/NotFound';
import HpiCheckApproval from './components/HpiCheckApproval';

const { TabPane } = Tabs;
const { Content } = Layout;

const mapStateToProps = (state) => {
    const { Lead_approval } = state.Leads;

    return {
        Lead_approval, views_permissions: state.App.Permissions.views_permissions,
    };
};


export default connect(mapStateToProps, null)(checkPermissionsHOC(class Lead_approval extends Component {
    componentDidMount() {
        this.props.dispatch(leadApprovalGetLeadsRequest());
    }

    componentWillUnmount() {
        this.props.dispatch({ type: 'RESET_PERMISSIONS' });
    }

    approveLead = (approve_kind, lead_id) => this.props.dispatch(setLeadApproveRequest({ lead_id, approve_kind, approve_value: true }));


    // count lead by each kind of approval (Blemish report, Price, HPI check)
    countLeadsThatNeedApprovalByTabs = (tab, data) => {
        let price_count = 0; let hpi_check_count = 0;

        if (data === null || !data.length) {
            return 0;
        }


        for (let i = 0; i <= data.length - 1; i++) {
            if (!data[i].approval) {
                continue;
            }
            if (data[i].approval.price && data[i].approval.price.requires_approval) {
                price_count += 1;
            }
            if (data[i].approval.hpi_check && data[i].approval.hpi_check.requires_approval) {
                hpi_check_count += 1;
            }
        }

        // return leads count depends on tab(kind of approval)
        return (tab === 'price')
            ? price_count
            : (tab === 'hpi_check')
                ? hpi_check_count
                : 0;
    };

    // divide and build content lead by each kind of approval (Price, HPI check)
    divideLeadsToTabs = (tab, leadsList) => {
        const blemish_report_content = []; const price_content = []; const
            hpi_check_content = [];

        for (let i = 0; i < leadsList.length; i++) {
            if (!leadsList[i].approval) {
                continue;
            }

            // build content for Price
            if (leadsList[i].approval.price && leadsList[i].approval.price.requires_approval && leadsList[i].ref_bike_lead) {
                price_content.push(
                    <div key={leadsList[i]._id}>
                        <div style={{
                            padding: '15px 5px', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                        }}
                        >
                            <div>
                                {
                                    leadsList[i].approval[tab].requires_approval_date
                                    && (
                                        <Fragment>
                                            Created:&nbsp;
                                            {leadsList[i].approval[tab].requires_approval_date}
                                            <Divider type="vertical" />
                                        </Fragment>
                                    )
                                }
                                <Link
                                    to={{ pathname: `/Leads/Lead_profile/${leadsList[i]._id}`, _id: leadsList[i]._id }}
                                    style={{ color: 'black' }}
                                >
                                    {
                                        leadsList[i].ref_bike_lead.ref_bike_brand
                                        && leadsList[i].ref_bike_lead.ref_bike_brand.name
                                    }
                                    &nbsp;
                                    {
                                        leadsList[i].ref_bike_lead.ref_bike_model
                                            ? leadsList[i].ref_bike_lead.ref_bike_model.name
                                            : leadsList[i].ref_bike_lead.unmaped_data && leadsList[i].ref_bike_lead.unmaped_data.bike_model
                                    }
                                    &nbsp;
                                    {
                                        leadsList[i].ref_bike_lead.ref_bike_model
                                            ? `${leadsList[i].ref_bike_lead.ref_bike_model.cc}cc`
                                            : `${leadsList[i].ref_bike_lead.unmaped_data && leadsList[i].ref_bike_lead.unmaped_data.bike_cc}cc`
                                    }
                                </Link>
                                <Divider type="vertical" />
                                {
                                    leadsList[i].ref_bike_lead.ref_bike_variant && leadsList[i].ref_bike_lead.ref_bike_variant.year
                                        ? leadsList[i].ref_bike_lead.ref_bike_variant.year
                                        : leadsList[i].ref_bike_lead.unmaped_data && leadsList[i].ref_bike_lead.unmaped_data.bike_year
                                }
                                <Divider type="vertical" />
                                {
                                    leadsList[i].ref_bike_lead.mileage
                                    && `${leadsList[i].ref_bike_lead.mileage} miles`
                                }
                                <Divider type="vertical" />
                                {
                                    leadsList[i].ref_bike_lead.vrm
                                        ? leadsList[i].ref_bike_lead.vrm
                                        : 'VRM missing'
                                }
                                <Divider type="vertical" />
                                {
                                    leadsList[i].ref_assigned_to && leadsList[i].ref_assigned_to.person
                                        ? (
                                            <Fragment>
                                                {leadsList[i].ref_assigned_to.person.first_name}
                                        &nbsp;
                                                {leadsList[i].ref_assigned_to.person.last_name}
                                            </Fragment>
                                        )
                                        : (
                                            <Fragment>
                                                No assigned agent
                                            </Fragment>
                                        )
                                }
                                {
                                    leadsList[i].valuations && leadsList[i].valuations.length
                                        ? (
                                            <Fragment>
                                                <Divider type="vertical" />
                                                Price:&nbsp;&pound;
                                                {leadsList[i].valuations[leadsList[i].valuations.length - 1].valuation}
                                                &nbsp;&nbsp;
                                                &bull;&nbsp;&nbsp;
                                                {leadsList[i].valuations[leadsList[i].valuations.length - 1].suggested_margin}
                                                {(leadsList[i].valuations[leadsList[i].valuations.length - 1].suggested_margin > 0)
                                            && (
                                                <>
                                                    Suggested Margin:&nbsp;&pound;
                                                    {leadsList[i].valuations[leadsList[i].valuations.length - 1].suggested_margin}
                                                    {' '}
                                                    (Auto Price)&nbsp;&nbsp;&bull;
                                                </>
                                            )
                                                }

                                                {(leadsList[i].valuations[leadsList[i].valuations.length - 1].retail_price && leadsList[i].valuations[leadsList[i].valuations.length - 1].retail_price > 0)
                                            && (
                                                <>
                                                    Actual Margin:&nbsp;&pound;
                                                    {leadsList[i].valuations[leadsList[i].valuations.length - 1].retail_price - leadsList[i].valuations[leadsList[i].valuations.length - 1].valuation}
&nbsp;&nbsp;&bull;

                                                &nbsp;&nbsp; Retail Price:&nbsp;&pound;
                                                    {leadsList[i].valuations[leadsList[i].valuations.length - 1].retail_price}
                                                </>
                                            )
                                                }
                                            </Fragment>
                                        )
                                        : (
                                            <Fragment>
                                                <Divider type="vertical" />
                                                Price not set
                                            </Fragment>
                                        )
                                }


                            </div>
                            <div>
                                <Button
                                    type="primary"
                                    size="small"
                                    style={{ marginRight: 10 }}
                                    onClick={() => this.approveLead('price', leadsList[i]._id)}
                                >
                                    Approve Price
                                </Button>

                                <DenyLeadApproveModal lead_id={leadsList[i]._id} approve_kind="price" />
                            </div>
                        </div>
                    </div>,
                );
            }

            // build content for HPI check
            if (leadsList[i].approval.hpi_check && leadsList[i].approval.hpi_check.requires_approval && leadsList[i].ref_bike_lead) {
                hpi_check_content.push(
                    <div key={leadsList[i]._id}>
                        <div style={{
                            padding: '15px 5px', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                        }}
                        >
                            <div>
                                {
                                    leadsList[i].approval[tab].requires_approval_date
                                    && (
                                        <Fragment>
                                            Created:&nbsp;
                                            {leadsList[i].approval[tab].requires_approval_date}
                                            <Divider type="vertical" />
                                        </Fragment>
                                    )
                                }
                                <Link
                                    to={{ pathname: `/Leads/Lead_profile/${leadsList[i]._id}`, _id: leadsList[i]._id }}
                                    style={{ color: 'black' }}
                                >
                                    {
                                        leadsList[i].ref_bike_lead.ref_bike_brand
                                        && leadsList[i].ref_bike_lead.ref_bike_brand.name
                                    }
                                    &nbsp;
                                    {
                                        leadsList[i].ref_bike_lead.ref_bike_model
                                            ? leadsList[i].ref_bike_lead.ref_bike_model.name
                                            : leadsList[i].ref_bike_lead.unmaped_data && leadsList[i].ref_bike_lead.unmaped_data.bike_model
                                    }
                                    &nbsp;
                                    {
                                        leadsList[i].ref_bike_lead.ref_bike_model
                                            ? `${leadsList[i].ref_bike_lead.ref_bike_model.cc}cc`
                                            : `${leadsList[i].ref_bike_lead.unmaped_data && leadsList[i].ref_bike_lead.unmaped_data.bike_cc}cc`
                                    }
                                </Link>
                                <Divider type="vertical" />
                                {
                                    leadsList[i].ref_bike_lead.ref_bike_variant && leadsList[i].ref_bike_lead.ref_bike_variant.year
                                        ? leadsList[i].ref_bike_lead.ref_bike_variant.year
                                        : leadsList[i].ref_bike_lead.unmaped_data && leadsList[i].ref_bike_lead.unmaped_data.bike_year
                                }
                                <Divider type="vertical" />
                                {
                                    leadsList[i].ref_bike_lead.mileage
                                    && `${leadsList[i].ref_bike_lead.mileage} miles`
                                }
                                <Divider type="vertical" />
                                {
                                    leadsList[i].ref_bike_lead.vrm
                                        ? leadsList[i].ref_bike_lead.vrm
                                        : 'VRM missing'
                                }
                                {
                                    leadsList[i].ref_assigned_to && leadsList[i].ref_assigned_to.person
                                        ? (
                                            <Fragment>
                                                <Divider type="vertical" />
                                                {leadsList[i].ref_assigned_to.person.first_name}
                                        &nbsp;
                                                {leadsList[i].ref_assigned_to.person.last_name}
                                            </Fragment>
                                        )
                                        : (
                                            <Fragment>
                                                <Divider type="vertical" />
                                                No assigned agent
                                            </Fragment>
                                        )
                                }
                                <Divider type="vertical" />

                                <HpiCheckApproval bike_id={leadsList[i].ref_bike_lead._id} />
                            </div>
                            <div>
                                <Button
                                    type="primary"
                                    size="small"
                                    style={{ marginRight: 10 }}
                                    onClick={() => this.approveLead('hpi_check', leadsList[i]._id)}
                                >
                                    Approve HPI Check
                                </Button>

                                <DenyLeadApproveModal lead_id={leadsList[i]._id} approve_kind="hpi_check" />
                            </div>
                        </div>
                    </div>,
                );
            }
        }

        // return array with content depends on tab(kind of approval)

        return (tab === 'price')
            ? price_content
            : (tab === 'hpi_check')
                ? hpi_check_content
                : undefined;
    };


    render() {
        const { views_permissions } = this.props;
        const view_parent_access = views_permissions['view://Leads/Lead_approval'];
        // check on leads get successfully and permissions
        if (!view_parent_access) {
            return <NotFound />;
        }
        return get('this.props.Lead_approval.leads[0]', 'approval')
            ? (
                <Spin tip="Fetching Data...">
                    <div>
                        Loading...
                    </div>
                </Spin>
            )
            : (
                <Spin spinning={this.props.Lead_approval.loading} tip="Fetching Data...">
                    <div className="lead-approval-container">
                        <Content>
                            <h3>
                                Lead Approval
                                <Tooltip title="Refresh leads">
                                    <Icon
                                        type="sync"
                                        style={{ fontSize: 20, marginLeft: 20 }}
                                        onClick={() => this.props.dispatch(leadApprovalGetLeadsRequest())}
                                    />
                                </Tooltip>
                            </h3>
                            <h4 className="subhead">List of leads that need either their price or HPI report approved.</h4>
                            {
                                this.props.Lead_approval.leads
                                       && (
                                           <div>
                                               <Tabs defaultActiveKey="1" tabBarStyle={{ minWidth: 700 }}>


                                                   {/* Price approval tab */}
                                                   <TabPane
                                                       tab={(
                                                           <Fragment>
                                                               <span style={{ marginRight: 5 }}>Price</span>
                                                               <Badge
                                                               count={this.countLeadsThatNeedApprovalByTabs('price', this.props.Lead_approval.leads)}
                                                               style={{ backgroundColor: '#1890ff', color: 'white' }}
                                                               className="customBadge"
                                                           />
                                                           </Fragment>
                                                       )}
                                                       key="1"
                                                   >
                                                       {
                                                           this.countLeadsThatNeedApprovalByTabs('price', this.props.Lead_approval.leads)
                                                               ? this.divideLeadsToTabs('price', this.props.Lead_approval.leads)
                                                               : <h4 className="subhead">All leads price approved!</h4>
                                                       }
                                                   </TabPane>

                                                   {/* HPI check approval tab */}
                                                   <TabPane
                                                       tab={(
                                                           <Fragment>
                                                               <span style={{ marginRight: 5 }}>HPI check</span>
                                                               <Badge
                                                               count={this.countLeadsThatNeedApprovalByTabs('hpi_check', this.props.Lead_approval.leads)}
                                                               style={{ backgroundColor: '#1890ff', color: 'white' }}
                                                               className="customBadge"
                                                           />
                                                           </Fragment>
                                                       )}
                                                       key="2"
                                                   >
                                                       {
                                                           this.countLeadsThatNeedApprovalByTabs('hpi_check', this.props.Lead_approval.leads)
                                                               ? this.divideLeadsToTabs('hpi_check', this.props.Lead_approval.leads)
                                                               : <h4 className="subhead">All leads HPI check approved!</h4>
                                                       }
                                                   </TabPane>
                                               </Tabs>
                                           </div>
                                       )
                            }
                        </Content>

                    </div>
                </Spin>
            );
    }
}, ['view://Leads/Lead_approval']));



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_approval/index.js